import axios, { AxiosInstance } from 'axios';
import { API_STAKING_BASE_URL } from 'utils/constants/common';

export interface DashboardInfo {
  pointsEarnedToday: number;
  maxPointsAvailableToday: number;
  totalPoints: number;
  rank: number;
  level: string;
  quests: Quest[];
}

interface Quest {
  id: string;
  category: string;
  title: string;
  points: number;
  status: string;
  claimFrequency: string;
  imageUrl: string;
  numberOfClaims: number;
  maxNumberOfClaims: number;
}

export class SFIbackendSvc {
  private axiosInstance: AxiosInstance;

  constructor({ baseURL }: { baseURL: string }) {
    this.axiosInstance = axios.create({
      baseURL,
    });
  }

  async getDashboardDetails({
    walletAddress,
  }: {
    walletAddress: string;
  }): Promise<DashboardInfo> {
    try {
      const params = new URLSearchParams();
      if (walletAddress) params.append('walletAddress', walletAddress);
      const url = `/staking/v1/dashboard${params.toString() ? `?${params.toString()}` : ''}`;
      const response = await this.axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export const sfiBackendSvc = new SFIbackendSvc({
  baseURL: API_STAKING_BASE_URL,
});
